// Web-push helpers extracted from app.jsx (decomposition).

// Convert a base64url VAPID public key into the Uint8Array that
// PushManager.subscribe() requires for applicationServerKey.
export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}
